function initDropdowns()
{
    if (!document.querySelectorAll(".watch-options-dropdown").length) {
     return false;
    }

    document.querySelectorAll(".watch-options-dropdown").forEach( el => {

     new Vue({
      el: el,
      delimiters: ['[[',']]'],
      data: {
       type: el.dataset.type || '',
       placeholder: el.dataset.placeholder || '',
       placeholderImage: '',
       locale: el.dataset.locale || '',
       options: JSON.parse(el.dataset.options) || [],
       opened: false
      },
      created() {
       if(this.type === 'caseback') {
        this.placeholder = this.options[0]?.title;
        this.placeholderImage = this.options[0]?.bynder_image || this.options[0]?.image;
       }

       if (this.type === "straps") {
        this.updateStrapSelectionFromHash();
       }

       // Add hashchange event listener
       window.addEventListener("hashchange", this.updateStrapSelectionFromHash);
      },
      beforeDestroy() {
       window.removeEventListener("hashchange", this.updateStrapSelectionFromHash);
     },      
      methods: {
          generateHref(option) {
              // Use pre-sanitized hash from the server if available
              if (option?.sanitized_hashes && option?.sanitized_hashes[this.locale]) {
                  return option.sanitized_hashes[this.locale];
              }
              // Fallback to client-side sanitization if needed
              const color = option?.texts?.[this.locale]?.color || '';
              const name = option?.texts?.[this.locale]?.name || '';
              return `${this.sanitizeTitle(`${color}-${name}`)}`;
          },
          sanitizeTitle(str) {
              return str
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-|-$/g, '');
          },
          handleStrapOptionClick(option) {
           this.opened = false;

           const hash = this.generateHref(option);
           window.location.hash = hash;
           const slider = document.getElementById("straps-slider");
           if (slider) {
               slider.scrollIntoView({ behavior: "smooth" });
           }
         },
         handleCasebackOptionClick(option) {
          this.opened = false;
          this.placeholder = option?.title;
          this.placeholderImage = option?.bynder_image || option?.image;

          if(option.watch.id) {
           app_data.id = option.watch.id;
          }         

          document.querySelector('.container.hwl.fc-section h2.color-dark-grey.info-text').innerHTML = option?.watch?.ref_no;
          document.querySelector('#appointmentContactBtn').dataset.watchName = option?.watch?.ref_no;

          if(document.querySelector('.watch__prices')) {
           document.getElementById('show-price')?.click();
          }
         },
         updateStrapSelectionFromHash() {
          const hash = window.location.hash.substring(1);
          const matchedOption = this.options.find(
            option => this.generateHref(option) === hash
          );
  
          if (matchedOption) {
            this.placeholder =
              matchedOption?.texts?.[this.locale]?.name +
              " " +
              matchedOption?.texts?.[this.locale]?.color;
            this.placeholderImage = matchedOption?.mat_image;
          }
        }         
      },
      template: `
       <div>
        <div class="watch-options-dropdown" v-if="type === 'straps'">
         <header v-on:click="opened = !opened"><img :src="[[ placeholderImage ]]" alt="" loading="lazy" v-if="placeholderImage" />[[placeholder]]</header>

         <ul v-if="opened">
          <li v-for="option in options" v-on:click="handleStrapOptionClick(option)">
           <img :src="[[ option.mat_image ]]" alt="" loading="lazy"/>
           [[ option?.texts?.[locale]?.name + ' ' +  option?.texts?.[locale]?.color ]]
          </li>
         </ul>
        </div>

        <div class="watch-options-dropdown" v-if="type === 'caseback'">
         <header v-on:click="opened = !opened">
          <img :src="[[ placeholderImage ]]" alt="" loading="lazy" v-if="placeholderImage" />
          [[ placeholder ]]
         </header>

         <ul v-if="opened">
          <li v-for="option in options" v-on:click="handleCasebackOptionClick(option)">
           <img :src="[[ option?.bynder_image || option?.image ]]" alt="" loading="lazy" v-if="option?.bynder_image || option?.image"/>
           <div :class="['caseback-placeholder', placeholder == option.title ?  'caseback-placeholder-selected' : '']" v-else></div>
           [[ option?.title ]]
          </li>
         </ul>
        </div>

       </div>
      `
     });

    });
}


export { initDropdowns };